export default __webpack_public_path__ + "static/media/SHAPE.3594f146.png";